<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Photo of Gronkowski Boys</a>
</li>
<li id="level1-front4">
<a href="#/front02">Copyright</a>
</li>
<li id="level1-front5">
<a href="#/front03">Gronk Lineup</a>
</li>
<li id="level1-front6">
<a href="#/front04">Introduction </a>
</li>
<li id="c01">
<a href="#/c01">A Star Is Born</a>
</li>
<li id="c02">
<span href="#/c02" title="Link target outside of Sample">Gordy: Papa Gronk</span>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">The Evolution of Training</span>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">Gordie Jr.: Doesn’t He Know the Rest of the Family Plays Football?</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">Mental Toughness</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">Dan: The Talented Workhorse</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">Competition and Physical Play</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Chris: Brains and a Pedigree</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">A New Generation of Tight Ends</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">Rob: The Superstar</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">Rob Explodes</span>
</li>
<li id="c12">
<span href="#/c12" title="Link target outside of Sample">Goose: Greatness Expected</span>
</li>
<li id="c13">
<span href="#/c13" title="Link target outside of Sample">Get Gronked!</span>
</li>
<li id="level1-back20">
<span href="#/back01" title="Link target outside of Sample">Acknowledgments</span>
</li>
<li id="level1-back21">
<span href="#/back02" title="Link target outside of Sample">About the Authors</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?011a19fc